import { AxiosInstance } from 'axios'

import { iamDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiDisableSamlRequest,
  DefaultApiEnableSamlRequest,
  DefaultApiEnforceSamlRequest,
  DefaultApiGetSamlConfigurationRequest,
  DefaultApiUpdateSamlConfigurationRequest,
  DefaultApiGetSamlMetadataRequest,
  DefaultApiGetLoginOptionsRequest,
  DefaultApiMakeSamlOptionalRequest,
  DefaultApiDisableTwoFactorAuthRequest,
  DefaultApiEnableTwoFactorAuthRequest,
  DefaultApiGetScimConfigurationRequest,
  DefaultApiUpdateScimConfigurationRequest,
  DefaultApiEnableScimRequest,
  DefaultApiDisableScimRequest,
  DefaultApiGenerateScimAccessTokenRequest,
  DefaultApiGetScimAccessTokenRequest,
  DefaultApiDeleteScimAccessTokenRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/iam'

export const disableSaml = async (
  instance: AxiosInstance,
  params: DefaultApiDisableSamlRequest
) => {
  return await iamDefaultApiFactory(instance).disableSaml(params)
}

export const enableSaml = async (
  instance: AxiosInstance,
  params: DefaultApiEnableSamlRequest
) => {
  return await iamDefaultApiFactory(instance).enableSaml(params)
}

export const enforceSaml = async (
  instance: AxiosInstance,
  params: DefaultApiEnforceSamlRequest
) => {
  return await iamDefaultApiFactory(instance).enforceSaml(params)
}

export const getSamlConfiguration = async (
  instance: AxiosInstance,
  params: DefaultApiGetSamlConfigurationRequest
) => {
  return await iamDefaultApiFactory(instance).getSamlConfiguration(params)
}

export const updateSamlConfiguration = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateSamlConfigurationRequest
) => {
  return await iamDefaultApiFactory(instance).updateSamlConfiguration(params)
}

export const getSamlMetadata = async (
  instance: AxiosInstance,
  params: DefaultApiGetSamlMetadataRequest
) => {
  return await iamDefaultApiFactory(instance).getSamlMetadata(params)
}

export const getLoginOptions = async (
  instance: AxiosInstance,
  params: DefaultApiGetLoginOptionsRequest
) => {
  return await iamDefaultApiFactory(instance).getLoginOptions(params)
}

export const makeSamlOptional = async (
  instance: AxiosInstance,
  params: DefaultApiMakeSamlOptionalRequest
) => {
  return await iamDefaultApiFactory(instance).makeSamlOptional(params)
}

export const disableTwoFactorAuth = async (
  instance: AxiosInstance,
  params: DefaultApiDisableTwoFactorAuthRequest
) => {
  return await iamDefaultApiFactory(instance).disableTwoFactorAuth(params)
}

export const enableTwoFactorAuth = async (
  instance: AxiosInstance,
  params: DefaultApiEnableTwoFactorAuthRequest
) => {
  return await iamDefaultApiFactory(instance).enableTwoFactorAuth(params)
}

export const getScimConfiguration = async (
  instance: AxiosInstance,
  params: DefaultApiGetScimConfigurationRequest
) => {
  return await iamDefaultApiFactory(instance).getScimConfiguration(params)
}

export const updateScimConfiguration = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateScimConfigurationRequest
) => {
  return await iamDefaultApiFactory(instance).updateScimConfiguration(params)
}

export const enableScim = async (
  instance: AxiosInstance,
  params: DefaultApiEnableScimRequest
) => {
  return await iamDefaultApiFactory(instance).enableScim(params)
}

export const disableScim = async (
  instance: AxiosInstance,
  params: DefaultApiDisableScimRequest
) => {
  return await iamDefaultApiFactory(instance).disableScim(params)
}

export const generateScimAccessToken = async (
  instance: AxiosInstance,
  params: DefaultApiGenerateScimAccessTokenRequest
) => {
  return await iamDefaultApiFactory(instance).generateScimAccessToken(params)
}

export const getScimAccessToken = async (
  instance: AxiosInstance,
  params: DefaultApiGetScimAccessTokenRequest
) => {
  return await iamDefaultApiFactory(instance).getScimAccessToken(params)
}

export const deleteScimAccessToken = async (
  instance: AxiosInstance,
  params: DefaultApiDeleteScimAccessTokenRequest
) => {
  return await iamDefaultApiFactory(instance).deleteScimAccessToken(params)
}

// Do Not Remove this line ===@import api client===
